// extracted by mini-css-extract-plugin
export default {"tableHeadStyle":"MachineManagementStyle_tableHeadStyle__5andw"};